import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Signer } from 'ethers';
import { ThirdwebSDK } from '@thirdweb-dev/react';
import vaultAbi from '../../../abis/ichi/vault.json';

async function mutation({
  address,
  amount,
  vaultId,
  signer
}: {
  address: string | undefined;
  amount: string;
  vaultId: string | undefined;
  signer: Signer | undefined;
}) {
  if (!address || !vaultId || !amount || !signer) {
    return;
  }

  try {
    const sdk = ThirdwebSDK.fromSigner(signer);

    const contract = await sdk.getContract(vaultId, vaultAbi);

    const res = await contract.call('withdraw', [amount, address]);

    return res;
  } catch (e) {
    console.error(e);
  }
}

export function useWithdrawFromIchiVault() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutation,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.STEER_VAULTS_POSITIONS]
      });
    }
  });
}
